module.exports = __webpack_public_path__ + "img/mrxweb.5307a009.svg";